import { createApi } from '@reduxjs/toolkit/query/react';
import { ReducerPaths } from '../../constants/reducerPaths';
import { baseQuery } from '../../utils/baseQuery';
import { generateAiData, overrideAiScores } from './mutations';
import { getCandidateAiData } from './queries/get-candidate-ai-data.query';
import { getCandidateAiScores } from './queries/get-candidate-ai-scores.query';
import { addAiScoreSlug } from './mutations/add-ai-score-slug';
import { overrideAiScoresBySlug } from './mutations/override-ai-scores-by-slug.mutation';

export const candidateAiApi = createApi({
  reducerPath: ReducerPaths.CANDIDATE_AI_DATA,
  baseQuery,
  endpoints: (builder) => ({
    generateAiData: generateAiData(builder),
    getCandidateAiData: getCandidateAiData(builder),
    overrideAiScores: overrideAiScores(builder),
    getCandidateAiScore: getCandidateAiScores(builder),
    addAiScoreSlug: addAiScoreSlug(builder),
    overrideAiScoresBySlug: overrideAiScoresBySlug(builder),
  }),
});

export const {
  useGenerateAiDataMutation,
  useGetCandidateAiDataQuery,
  useOverrideAiScoresMutation,
  useGetCandidateAiScoreQuery,
  useOverrideAiScoresBySlugMutation,
} = candidateAiApi;
